export const CLOSED_CANDIDATE_STAGES = ["rejected", "withdrawn", "talent_pool"] as const;

export type ClosedCandidateStage = (typeof CLOSED_CANDIDATE_STAGES)[number];

export function isClosedCandidateStage(stage: string): boolean {
  return (CLOSED_CANDIDATE_STAGES as readonly string[]).includes(stage);
}
